<template>
  <div id="feedback-modal" :class="`step-${step}`">
    <font-awesome-icon
      class="close-icon"
      :icon="'xmark'"
      size="4x"
      @click="cancel"
    />
    <transition
      appear
      mode="out-in"
      tag="div"
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <feedback-user-select
        v-if="step === 0"
        @showNext="showNext"
        key="feedback-user-select"
      />
      <feedback-form
        v-else
        :receiverUserId="userId"
        :initialReason="initialReason"
        :initialAmount="initialAmount"
        :initialCategory="initialCategory"
        :parentId="parentId"
        key="feedback-form"
      />
    </transition>
  </div>
</template>


<script>
import FeedbackUserSelect from './FeedbackUserSelect';
import FeedbackForm from './FeedbackForm';

export default {
  name: 'FeedbackModal',
  components: {
    FeedbackForm,
    FeedbackUserSelect,
  },
  mixins: [],
  props: {
    receiverUserId: {
      required: false,
      type: String,
    },
    initialReason: {
      type: String,
      required: false,
    },
    initialAmount: {
      type: Number,
      required: false,
    },
    initialCategory: {
      type: Number,
      required: false,
    },
    parentId: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      step: 0,
      userId: undefined,
    };
  },
  async created() {
    if (this.receiverUserId) {
      this.userId = this.receiverUserId;
      this.step = 1;
    }
  },
  computed: {},
  methods: {
    showNext(user) {
      this.userId = user._id;
      this.step = 1;
    },
    cancel() {
      this.$eventBus.closeModal();
    },
  },
};
</script>

<style lang="scss" scoped>
#feedback-modal {
  min-width: 450px;
  text-align: left;
  @media (min-width: 992px) {
    min-width: 650px;
  }
  transition: max-height 0.45s ease-in;
  &.step-0 {
    max-height: 750px;
  }
  &.step-1 {
    max-height: 280px;
  }
  padding: 20px;
  .row {
    margin: 10px 0;
  }
  .close-icon {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 1;
    font-size: 16px;
    color: #aaa;
    cursor: pointer;
    &:hover {
      color: $base-font-color;
    }
  }
}
</style>

